// extracted by mini-css-extract-plugin
export default {"HeaderTittleBox":"headerTittle_HeaderTittleBox__VaRcI"};